import { validationMixin } from 'vuelidate';

export default {
    name: 'aFormMixin',
    components: {
        validationMixin,
    },
    mixins: [validationMixin],
    props: [
        'iniData', //for setting the initial data

        //for the aForm-component
        'hideCancel', // for hiding the cancel button
        'hideMessages', // for hiding the error messages
        'hideActions', // for hiding the actions
        'hideChanges', //for hiding the changes notifciation
        'iniDisabled', //setting the form disabled
        'eventHandlerName', //for emitting events on the global bus
        'cancelLabel', //Label of the cancel-button
        'btnLabel', //Label of the save-button
        'loadingLabel', //Label of the loading message
        'stickyActions',
    ],
    data() {
        return {
            editData: {},
            isLoading: false,
            isError: false,
            isSuccess: false,
            isDifferent: false,
            isChanged: false,
            errorLog: null,
        };
    },
    computed: {
        isDisabled: function () {
            if (this.isLoading || this.iniDisabled) {
                return true;
            }
            return false;
        },
    },
    watch: {
        iniData: {
            handler: function (newValue, oldValue) {
                this.handleIniData();
            },
            deep: true,
        },
    },
    created: function () {
        this.handleI18n();
        this.handleIniData();

        if (this.eventHandlerName) {
            document.addEventListener(`${this.eventHandlerName}.isSuccess`, this.onSuccess);
            document.addEventListener(`${this.eventHandlerName}.isError`, this.onError);
            document.addEventListener(`${this.eventHandlerName}.onReset`, this.resetForm);
            if (this.$eventHub) {
                this.$eventHub.$on(this.eventHandlerName + '.isSuccess', this.onSuccess);
                this.$eventHub.$on(this.eventHandlerName + '.isError', this.onError);
                this.$eventHub.$on(this.eventHandlerName + '.onReset', this.resetForm);
            }
        }
    },
    beforeDestroy() {
        if (this.eventHandlerName) {
            document.removeEventListener(`${this.eventHandlerName}.isSuccess`, this.onSuccess);
            document.removeEventListener(`${this.eventHandlerName}.isError`, this.onError);
            document.removeEventListener(`${this.eventHandlerName}.onReset`, this.resetForm);
            if (this.$eventHub) {
                this.$eventHub.$off(this.eventHandlerName + '.isSuccess', this.onSuccess);
                this.$eventHub.$off(this.eventHandlerName + '.isError', this.onError);
                this.$eventHub.$off(this.eventHandlerName + '.onReset', this.resetForm);
            }
        }
    },
    methods: {
        async handleI18n() {
            if (this.$i18n) {
                //only if i18n is initiated
                let currentLang = this.$i18n.locale;
                let messages = this.$i18n.messages;
                if (messages[currentLang] && !messages[currentLang].forms) {
                    //only load the current langauge and when not already added
                    const lang = require(`./../i18n/forms.${currentLang}.json`);
                    this.$i18n.setLocaleMessage(currentLang, {
                        ...messages[currentLang],
                        ...lang,
                    });
                }
            }
        },
        handleIniData() {
            if (this.iniData) {
                if (
                    !this.iniDisabled &&
                    Object.keys(this.editData).length > 0 &&
                    (this.editData.id || this.editData.ID)
                ) {
                    //editData has data
                    //user is editing: don't allow the data to be changed, instead show a message
                    this.isChanged = true;
                } else {
                    //when not in edit: update data
                    this.editData = JSON.parse(JSON.stringify(this.iniData));
                }
            } else {
                this.editData = {};
            }
        },
        onSuccess: function () {
            this.isError = false;
            this.isLoading = false;
        },
        onError: function (event) {
            if (event && event.detail) {
                this.errorLog = event.detail;
            } else {
                this.errorLog = event;
            }
            this.isError = true;
            this.isLoading = false;
        },
        save: async function () {
            await this.$validate();

            if (!this.$v.$invalid) {
                this.isLoading = true;
                if (this.$eventHub) {
                    this.$eventHub.$emit(this.eventHandlerName + '.isLoading');
                }
                document.dispatchEvent(new Event(`${this.eventHandlerName}.isLoading`));

                this.$emit('onSave', {
                    data: this.editData,
                    eventHandlerName: this.eventHandlerName,
                });
                this.$v.$reset();
            }
        },
        async $validate(v) {
            v = v || this.$v;
            v.$touch();
            await this.$nextTick();
            return new Promise((resolve) => {
                var unwatch = this.$watch(
                    () => v.$pending,
                    (isPending) => {
                        if (!isPending) {
                            resolve(!v.$invalid);
                            if (unwatch) {
                                unwatch();
                            }
                        }
                    },
                    {
                        immediate: true,
                    }
                );
            });
        },
        cancel: function () {
            this.resetForm();
            this.$emit('onCancel', this.editData);
        },
        resetForm: function () {
            if (this.iniData) {
                //reset editData to original state... if any.
                this.editData = JSON.parse(JSON.stringify(this.iniData));
            } else if (Array.isArray(this.editData)) {
                this.editData = [];
            } else if (typeof this.editData == 'object') {
                this.editData = {};
            } else {
                this.editData = null;
            }
            this.$v.$reset();
            this.isLoading = false;
        },
        handleKeys: function (e) {
            if ((e.metaKey || e.ctrlKey) && e.keyCode == 13) {
                e.preventDefault();
                this.save();
            } else if (e.keyCode == 27) {
                //on escape
                e.preventDefault();
                this.cancel();
            }
        },
    },
};
